export default __webpack_public_path__ + "static/media/Promotion_img2_En.b0c248f4.webp";